'use client';

import { Button } from '@ahafood/ui/components/button';
import { ChevronLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { trackEvent } from '@/lib/event-tracking';

export default function TrendingHeader() {
  const router = useRouter();
  const trackBackButton = () => {
    trackEvent('click_button', {
      action_time: Math.floor(Date.now() / 1000),
      button_name: 'is_back',
      button_location: 'trending_zone',
    });
    router.back();
  };

  return (
    <div className="bg-transparent fixed top-0 inset-x-0 z-50 w-full max-w-screen-xl mx-auto items-start">
      {/* Header Banner */}
      <div
        className="relative h-[180px] overflow-hidden rounded-b-[24px] flex items-center p-4"
        style={{
          backgroundImage: 'url(/static/images/trending-header.webp)',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        }}
      >
        <div className="flex mb-12">
          <Button
            variant="ghost"
            // size="icon"
            className="flex items-center size-9 text-xl font-bold bg-neutral-30 hover:bg-neutral-40 rounded-full [&_svg]:stroke-2 [&_svg]:text-white backdrop-blur-md shadow-xl hover:scale-110 transition-transform"
            onClick={trackBackButton}
          >
            <ChevronLeft />
          </Button>

          {/* Content */}
          <div className="relative flex items-center px-4">
            <div className="flex-1">
              <h1 className="text-2xl font-bold text-primary-50">Xu hướng</h1>
              <p className="text-xs text-neutral-60">
                Top món ngon đang được yêu thích
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
